import { render, staticRenderFns } from "./PhasesForm.vue?vue&type=template&id=22edea62"
import script from "./PhasesForm.vue?vue&type=script&lang=js"
export * from "./PhasesForm.vue?vue&type=script&lang=js"
import style0 from "./PhasesForm.vue?vue&type=style&index=0&id=22edea62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports